import Check from '../components/Check/Check'

let routes = {
    path: '/check',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/check',
            name: 'Marcar ponto',
            component: Check
        }
    ]
};


export default routes



// WEBPACK FOOTER //
// ./src/router/check.js